import Nouislider from "nouislider-react";
import React, { useEffect, useState } from "react";
import "nouislider/distribute/nouislider.css";
import { NumericFormat } from "react-number-format";

function NumericContainer({
  onChange,
  defaultValue,
  readOnly,
  validationRules,
  type,
}) {
  const [currentValue, setCurrentValue] = useState(
    defaultValue ? +defaultValue.toString().replace(",", ".").toLowerCase() : 0,
  );
  const [prevValue, setPrevValue] = useState(
    defaultValue ? +defaultValue.toString().replace(",", ".").toLowerCase() : 0,
  );
  const [inputValue, setInputValue] = useState(
    defaultValue ? +defaultValue.toString().replace(",", ".").toLowerCase() : 0,
  );
  const [error, setError] = useState("");
  const [min, setMin] = useState(undefined);
  const [max, setMax] = useState(undefined);
  const [step, setStep] = useState(0.1);
  const [isSliding, setIsSlinding] = useState(false);

  useEffect(() => {
    const numValue =
      defaultValue != null
        ? +defaultValue.toString().replace(",", ".").toLowerCase()
        : 0;
    setCurrentValue(numValue);
    setPrevValue(numValue);
    setInputValue(defaultValue);
    const validationRulesMin = validationRules?.find((x) => x.type === "min");
    const validationRulesMax = validationRules?.find((x) => x.type === "max");
    const validationRulesStep = validationRules?.find((x) => x.type === "step");

    if (validationRulesMin?.value && validationRulesMin?.value !== "-") {
      setMin(+validationRulesMin.value.toString().replace(",", "."));
    } else if (type === "numericslider") {
      setMin(undefined);
    }
    if (validationRulesMax?.value && validationRulesMax?.value !== "-") {
      setMax(+validationRulesMax.value.toString().replace(",", "."));
    } else if (type === "numericslider") {
      setMax(undefined);
    }
    if (validationRulesStep?.value && validationRulesStep?.value !== "-") {
      setStep(+validationRulesStep.value.toString().replace(",", "."));
    } else if (type === "numericslider") {
      setStep(0.1);
    }
  }, [defaultValue, validationRules]); //eslint-disable-line

  function toDecimalString(num) {
    if (typeof num !== "number" || !isFinite(num)) return String(num);
    const str = num.toString();
    if (!str.includes("e") && !str.includes("E")) return str;
    const [mantissa, exp] = str.split(/e/i);
    const expNum = parseInt(exp, 10);
    const mantissaDecimals = (mantissa.split(".")[1] || "").length;
    const decimalPlaces = Math.max(0, mantissaDecimals - expNum);
    return num.toFixed(decimalPlaces);
  }

  function roundToStep(value, step, min = 0) {
    const base = min || 0;
    return (Math.round((value - base) / step) * step + base).toString();
  }

  function truncateToStepDecimals(value, step) {
    if (value.toString().includes(",") || value.toString().includes(".")) {
      const decimals = (step.toString().split(".")[1] || "").length;
      return Number(value).toFixed(decimals);
    } else return value;
  }

  function handleEndSlider(value) {
    let tmpValue = parseFloat(value.toString().replace(",", ".").toLowerCase());

    if (type === "numericslider") {
      tmpValue = truncateToStepDecimals(
        roundToStep(
          parseFloat(value.toString().replace(",", ".").toLowerCase()),
          step,
          min,
        ),
        step,
      );
    }

    if (checkAllowed(tmpValue)) {
      const decStr = toDecimalString(+tmpValue);
      setPrevValue(+tmpValue);
      setCurrentValue(decStr);
      setInputValue(decStr.replace(".", ","));
      onChange(+tmpValue);
      setError("");
    } else {
      if (min !== undefined && max === undefined && tmpValue < min) {
        setError(
          "La valeur saisie doit être supérieure ou égale à " + min.toString(),
        );
      } else if (min === undefined && max !== undefined && tmpValue > max) {
        setError(
          "La valeur saisie doit être inférieure ou égale à " + max.toString(),
        );
      } else
        setError(
          "La valeur saisie doit être comprise dans l’intervalle { " +
            (min !== undefined ? min.toString() : "-") +
            " ; " +
            (max !== undefined ? max.toString() : "-") +
            " }",
        );
      const prevDecStr = toDecimalString(+prevValue);
      setInputValue(prevDecStr.replace(".", ","));
      setCurrentValue(prevDecStr);
      onChange(+prevValue);
    }
  }

  function checkAllowed(tmpValue) {
    return (
      (min === undefined && max === undefined) ||
      (min !== undefined && max === undefined && tmpValue >= parseFloat(min)) ||
      (min === undefined && max !== undefined && tmpValue <= parseFloat(max)) ||
      (min !== undefined &&
        max !== undefined &&
        tmpValue >= parseFloat(min) &&
        tmpValue <= parseFloat(max))
    );
  }

  return (
    <div className="slider-container">
      {type === "numericslider" && min !== undefined && max !== undefined && (
        <>
          <div
            className="d-flex justify-content-between"
            style={{ paddingBottom: "6px" }}
          >
            <span>
              {(min || min === 0 ? min : "").toString().replace(".", ",")}
            </span>
            <span>
              {(max || max === 0 ? max : "").toString().replace(".", ",")}
            </span>
          </div>
          <Nouislider
            range={{
              ...((min || min === 0) && {
                min: +parseFloat(min),
              }),
              ...((max || max === 0) && {
                max: +parseFloat(max),
              }),
            }}
            start={+prevValue}
            onStart={() => setIsSlinding(true)}
            onEnd={(e) => {
              setIsSlinding(false);
              handleEndSlider(+e);
            }}
            onChange={(e) => {
              handleEndSlider(+e);
            }}
            onSlide={(e) => setCurrentValue(+e)}
            disabled={readOnly}
            connect
            step={+parseFloat(step)}
          />
        </>
      )}
      <NumericFormat
        type="text"
        decimalSeparator=","
        allowLeadingZeros
        valueIsNumericString={true}
        value={isSliding ? currentValue : inputValue}
        onValueChange={(values) =>
          setInputValue(values.value.replace(".", ","))
        }
        onBlur={(e) => {
          handleEndSlider(e.target.value);
        }}
        onKeyDown={(e) =>
          e.key === "Enter" ? handleEndSlider(e.target.value) : ""
        }
        className="form-control"
        disabled={readOnly}
      />
      {error && <p className="text-danger m-0">{error}</p>}
    </div>
  );
}

export default NumericContainer;
